// extracted by mini-css-extract-plugin
module.exports = {"icon":"DatePickerInput_icon__Jgeky","rightSection":"DatePickerInput_rightSection__XZWtR","input":"DatePickerInput_input__vIU7P","day":"DatePickerInput_day__gqOVd"};